import {Component, input, OnInit} from '@angular/core';
import {StepWithAttachmentsComponent} from '../../base/step-with-attachments.component';
import {Validators} from '@angular/forms';
import {SubsidyType} from '../../models/subsidy-type.type';

@Component({
	selector: 'tvsub-sign-step',
	templateUrl: './sign-step.component.html',
	styleUrls: ['./sign-step.component.scss'],
	standalone: false
})
export class SignStepComponent extends StepWithAttachmentsComponent implements OnInit {
	type = input.required<SubsidyType>();

	constructor() {
		super();
	}

	ngOnInit() {
		this.manuallySetSubsidyType(this.type());

		this.form = this.fb.group({
			accept: [false, Validators.requiredTrue],
		});
	}

	override getData(formData: any): any {
		return {};
	}
}
